import React, { useEffect, useState } from 'react';

import AdminLayout from 'components/Layouts/AdminLayout';
import BlogpostsOverview from 'fragments/Admin/BlogpostsOverview';
import axios from 'axios';
import Title from 'components/Typography/Title';
import { InertiaLink } from '@inertiajs/inertia-react';
import Eye from 'components/Icons/Eye';
import Delete from 'components/Icons/Delete';
import Interest from 'components/Icons/Interest';
import { format } from 'date-fns';
import SimpleDate, { getDate } from 'components/DateFormatter';
import Button from 'components/Forms/Components/Button';
import { Inertia } from '@inertiajs/inertia';

export default function Deposits() {

    const [deposits, setDeposits] = useState(null as any);

    async function deleteDeposit(id) {
        if (confirm("Opravdu chcete tuto úložku odstranit? Akce je nevratná")) {
            axios.delete('/api/deposits/delete', { data: { id: id } }).then((res) => {
                console.log(res)
                if (res.status == 200) {
                    setDeposits(deposits.filter(deposit => deposit.id != id))
                }
            })
        }
    }

    async function user(uuid) {
        axios.get('/api/users/' + uuid).then(res => {
            console.log(res)
            alert(`
Jméno a příjmení: ${res.data.user.firstName} ${res.data.user.lastName} 
Email: ${res.data.user.email} 
Telefon: ${res.data.user.tel} 
Adresa: ${res.data.user.street}, ${res.data.user.city} ${res.data.user.postalCode} 
Firma: ${res.data.user.companyInvoice ? res.data.user.companyName + ", " + res.data.user.ICO : "Ne"}`)
        })
    }

    useEffect(() => {
        axios.get('/api/deposits/all').then((res) => {
            console.log(res)
            setDeposits(res?.data?.deposits)
        })
    }, []);

    return (
        <AdminLayout>
            <div className="min-h-screen  px-5 lg:px-32 pt-32">
                <div className="flex justify-between items-baseline">
                    <Title level={2}>Úložky</Title>
                    <div className="inline-flex">
                        <Button theme="secondary" link="/admin/ulozky/nova">+ Přidat</Button>
                    </div>

                </div>

                <div className="mt-4 overflow-x-auto w-full">
                    {deposits ?
                        <table className="table-auto data-table-design">
                            <thead>
                                <tr>
                                    <th className='w-5'>ID</th>
                                    <th>Stav</th>
                                    <th>Název</th>
                                    <th>Číslo úložky</th>
                                    <th>Typ úložky</th>
                                    <th>Hodnota</th>
                                    <th>Závěrečná bilance</th>
                                    <th>Hodnota Kč</th>
                                    <th>Závěrečná bilance Kč</th>
                                    <th>Úrok</th>
                                    <th>Celkový úrok</th>
                                    <th>Termín skončení úložky</th>
                                    <th>Uživatel</th>
                                    <th>Datum platby</th>
                                    <th>Kód platby</th>
                                    <th>Stav platby</th>
                                    <th>Bonus k úroku</th>
                                    <th>Využitý promo kód</th>
                                </tr>
                            </thead>

                            <tbody>
                                {deposits?.map((deposit, i) => (
                                    <tr>
                                        <td>{deposit?.id}</td>
                                        <td><State deposit={deposit} /></td>
                                        <td><EditOnClick deposit={deposit} edit="name" /></td>
                                        <td><EditOnClick deposit={deposit} edit="number" /></td>
                                        <td><EditOnClick deposit={deposit} edit="type" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="amountBTC" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="finalBilance" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="amountCzk" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="finalCzkBilance" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="interest" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="finalInterest" /></td>
                                        <td><EditOnClick deposit={deposit} edit="expiration" /> </td>
                                        <td className='flex' > <div className="">{deposit?.userName} &nbsp;</div><EditOnClick deposit={deposit} edit="user_UUID" /><span onClick={() => user(deposit?.user_UUID)} className='hover:text-white-70'><Eye /></span></td>
                                        <td> <EditOnClick deposit={deposit} edit="payment" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="paymentId" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="paymentStatus" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="interestBonus" /></td>
                                        <td> <EditOnClick deposit={deposit} edit="promo_code" /></td>


                                        <td>
                                            <span className="text-red-400 font-semibold cursor-pointer" onClick={() => deleteDeposit(deposit?.id)}>Smazat</span>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>


                        </table>
                        :
                        <>
                            <div className="w-full h-10 bg-white-10"></div>
                            <div className="h-4"></div>
                            <div className="w-full h-40 bg-white-10"></div>
                        </>
                    }
                </div>
            </div>
        </AdminLayout>
    );
}


function State({ deposit }) {

    const now = new Date()

    if (deposit.paymentStatus == "paid") {
        if (getDate(deposit.expiration) >= new Date() || (!deposit.expiration && deposit.type == "variable")) {
            return (
                <div className="bg-green text-white font-semibold text-sm text-center px-4 rounded-full">Probíhající</div>
            )
        }
        else {
            return (
                <div className="bg-white-30 text-white font-semibold text-sm text-center px-4 rounded-full">Dokončená</div>
            )
        }

    }
    else {
        return (
            <div className="bg-red-400 bg-opacity-70 text-white font-semibold text-sm text-center px-4 rounded-full">Nezaplacená</div>
        )
    }


}

function EditOnClick({ deposit, edit }: { deposit: any, edit: string }) {

    async function change() {
        let input = prompt("Pokud si přejete změnit tento údaj, zapište zde novou hodnotu:", deposit[edit])
        let uDeposit = deposit
        if (uDeposit?.userName) {
            uDeposit.userName = undefined
        }


        if (input != deposit[edit] && input !== null) {
            axios.post("/api/deposits/edit", {
                ...uDeposit,
                [edit]: input,
                updated_at: format(new Date(), "yyyy-MM-dd hh:mm:ss"),
                created_at: format(new Date(uDeposit.created_at), "yyyy-MM-dd hh:mm:ss")
            }).then(res => {
                console.log(res)
                if (res.status == 200) {
                    Inertia.visit("/admin/ulozky")
                }
            })
        }
    }
    if (deposit[edit]) {
        return (
            <span style={{ cursor: "context-menu" }} onClick={() => change()} className='hover:text-white-70 w-full h-full'>{deposit[edit]}</span>
        )
    }
    else {
        return (
            <div style={{ cursor: "context-menu" }} onClick={() => change()} className='hover:text-white-70 w-full h-full text-center bg-white-10'>+</div>
        )
    }

}